export const payrollStatementNotificationsPath = (
  businessId: string,
  periodStart: string,
) =>
  `/businesses/${businessId}/pay_periods/${periodStart}/payroll_statement_notifications`;

export const payrollStatementNotificationsKey = (
  businessId: string | null,
  periodStart: string | null,
) => ["payroll-statement-notifications", businessId, periodStart] as const;

export const payrollStatementPackApprovalsKey = (
  businessId: string | null,
  periodStart: string | null,
) => ["payroll-statement-pack-approvals", businessId, periodStart] as const;

export const payrollStatementProjectionBuildKeyPrefix = (
  businessId: string | null,
  periodStart: string | null,
) => ["payroll-statement-projection-build", businessId, periodStart] as const;

export const payrollStatementProjectionBuildKey = (
  businessId: string | null,
  periodStart: string | null,
  generationKey: string | null,
) =>
  [
    ...payrollStatementProjectionBuildKeyPrefix(businessId, periodStart),
    generationKey,
  ] as const;

export const payrollStatementDeliveryStatusKey = (
  businessId: string | null,
  periodStart: string | null,
  batchId: string | null,
) =>
  [
    "payroll-statement-delivery-status",
    businessId,
    periodStart,
    batchId,
  ] as const;
